import { StandaloneResultsValuesContext } from '@rhg/providers/standalone-results-values';
import { useContext } from 'react';

export function useStandaloneResultsValues() {
    return useContext(StandaloneResultsValuesContext);
}
